<template>
	<div>
		<p-card class="tw-mb-4">
			<div class="tw-px-8 relative">
				<job-complete-validator-tag :jobs="selectedJobs" :job-validator="questionStepValidator" />
				<p-items-carousel
					uuid="questions-carousel"
					:items="selectedJobs"
					:per-view="5"
					control-mx="-70px"
					:breakpointPerView="{
						1080: {
							perView: 3,
						},
					}"
				>
					<template slot="default" slot-scope="{ item: job }">
						<job-card-selection
							class="tw-leading-text"
							style="height: 80px"
							:text="job.name"
							:focused="isFocusedJob(job)"
							:checked="jobSkillQuestionCompleted(job, lastStepConfig.minSelectedQuestions)"
							@click="focusJob(job)"
						>
						</job-card-selection>
					</template>
				</p-items-carousel>
			</div>
		</p-card>
		<div class="tw-flex tw-justify-between tw-mb-2">
			<p class="tw-text-app-color-primary tw-mb-2 text-lg">
				Seleccionar de {{ lastStepConfig.minSelectedQuestions }} a
				{{ lastStepConfig.maxSelectedQuestions }} comportamientos observables
			</p>
			<question-type-selector
				:questions-type="focusedJob.questionsType"
				@questionTypeChanged="handleQuestionTypeChanged($event)"
			></question-type-selector>
		</div>
		<p-card class="overflow-hidden tw-p-none">
			<evaluation-questions-section
				:skills="focusedJob.skills"
				:last-step-config="lastStepConfig"
				:questions-type="focusedJob.questionsType"
				@onSkillUpdate="handleOnSkillUpdate($event)"
			/>
			<p-horizontal-divider class="tw-m-none" />
			<div class="tw-text-center tw-p-6">
				<p-button @click="handlePrevStep()" type="primary" class="tw-px-12">
					Atrás
				</p-button>
				<p-button
					:disabled="!stepIsCompleted.isComplete"
					@click="handleNextStep()"
					type="secondary"
				>
					Siguiente
				</p-button>
				<!-- <p-button
					@click="$emit('saveClick')"
					type="secondary"
					:disabled="!stepIsCompleted.isComplete"
				>
					Guardar
				</p-button> -->
			</div>
		</p-card>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import { assoc, equals, head, isEmpty, pathOr, prop } from 'ramda';
import PCard from '../../../shared/components/ui/Card/p-card';
import JobCardSelection from '../second-step/components/job-card-selection';
import PItemsCarousel from '../../../shared/components/content/p-items-corousel';
import PHorizontalDivider from '../../../shared/components/ui/p-horizontal-divider';
import PButton from '../../../shared/components/ui/p-button';
import EvaluationQuestionsSection from './components/evaluation-questions-section';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from '../../store/store.constant';
import { tseNamespace } from '../../utils';
import { updateElementInList, findIndexElementInList } from '../../../shared/utils/listElements';
import { jobSkillQuestionCompleted } from './evaluation-questions.utils';
import JobCompleteValidatorTag from '../../commons/job-complete-validator-tag';
import { tseStepIsCompleted } from '../../utils/tse.utils';
import QuestionTypeSelector from './components/question-type-selector';

export default {
	components: {
		QuestionTypeSelector,
		JobCompleteValidatorTag,
		EvaluationQuestionsSection,
		PButton,
		PHorizontalDivider,
		PItemsCarousel,
		JobCardSelection,
		PCard,
	},
	name: 'EvaluationQuestions',
	props: {
		lastStepConfig: {
			default: () => ({
				minSelectedQuestions: 0,
			}),
		},
	},
	data() {
		return {
			focusedJob: {},
		};
	},
	computed: {
		...mapState(THREE_SIXTY_EVALUATION_NAMESPACE, {
			selectedJobs: pathOr([], ['evaluationFlow', 'selectedJobs']),
		}),
		stepIsCompleted() {
			return tseStepIsCompleted(this.questionStepValidator, this.selectedJobs);
		},
	},
	methods: {
		jobSkillQuestionCompleted,
		questionStepValidator(j) {
			if (!prop('minSelectedQuestions', this.lastStepConfig)) return false;
			return jobSkillQuestionCompleted(j, this.lastStepConfig.minSelectedQuestions);
		},
		isFocusedJob(job) {
			return equals(prop('id', job), prop('id', this.focusedJob));
		},
		focusJob(job) {
			this.focusedJob = job;
		},
		handleNextStep() {
			this.$store.dispatch(tseNamespace('nextStep'));
		},
		handlePrevStep() {
			this.$store.dispatch(tseNamespace('prevStep'));
		},
		handleOnSkillUpdate(updatedSkill) {
			const updatedSkills = updateElementInList(updatedSkill, this.focusedJob.skills);
			this.$store.dispatch(
				tseNamespace('updateSelectedJob'),
				assoc('skills', updatedSkills, this.focusedJob),
			);
		},
		handleQuestionTypeChanged(questionsType) {
			this.$store.dispatch(
				tseNamespace('updateSelectedJob'),
				assoc('questionsType', questionsType, this.focusedJob),
			);
		},
	},
	watch: {
		selectedJobs: {
			handler() {
				if (isEmpty(this.focusedJob) && !!this.selectedJobs) {
					this.focusedJob = head(this.selectedJobs);
				}
				if (!isEmpty(this.focusedJob) && !!this.selectedJobs) {
					const focusedIndex = findIndexElementInList(this.focusedJob, this.selectedJobs);
					this.focusedJob = prop(focusedIndex, this.selectedJobs);
				}
			},
			immediate: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/third-step/evaluation-questions.vue